import { EvtHeader } from "components/header";
import React from "react";
import DepartmentForm from "../form";

const CreateDepartment = () => {
  return (
    <div className="flex-1 max-w-md">
      <EvtHeader title="Create Department" />
      <div className="p-6 max-w-2xl">
        <DepartmentForm />
      </div>
    </div>
  );
};

export default CreateDepartment;
